export default __webpack_public_path__ + "static/media/ELEMENTOS_07.126bb314.png";